import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import { GetMasterData } from "Actions/MasterCodeAction";
import Add from "@material-ui/icons/Add";
import { instanceMultipart, instance } from "Actions/AxiosInstance";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import editIcon from "Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import uploadIcon from "Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import emptyImgae from "Assets/Svg/career-page.svg";
import classNames from "classnames";
import {
  setSaveProgress,
  removeSaveProgress,
} from "Actions/SaveProgressAction";

// import { getDocTypeid } from "../../../Utils";
// import { instance } from "Actions/AxiosInstance";
import DynamicForm from "Component/DynamicForm";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import DrawerHeader from "Component/Headers/drawerHeader";
import PageHeader from "Component/Headers/pageHeader";
import ThumbnailBig from "Component/Thumbnail/ThumbnailRectangleBase64";
import Picker from "emoji-picker-react";
import get from "lodash/get";
import { TDTypeConsts } from "Module/Subscription/business-configration/commons";
import { withSnackbar } from "notistack";
import React from "react";
import Dropzone from "react-dropzone";
import ReactQuill from "react-quill";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  fileToBase64Link,
  getFormattedImageLink,
  convertTOBase64,
  getDocTypeid,
} from "Utils";
import { FormatListBulleted } from "@material-ui/icons";
import CallOutNew from "Component/Headers/callOutNew";

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
];

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isedit: false,
      imgname: "",
      open: false,
      isDisableSaveButton: false,
      postData: props.postData,
      listdata: props.listdata,
      sectiondetail: {
        careerpagesectiondetailid: null,
        title: null,
        description: null,
        linkedid: null,
        locationame: null,
        documentpath: null,
        documenttypeid: null,
      },
      documentpath: [],
      locationame: "",
      sectionType: [],
      valuename: "",
      isOverview: false,
      isValues: false,
      isBenifits: false,
      isTeamStructure: false,
      flag: false,
      // postData.sectiontypeid: "",
      modules: props.modules1,
      formats,
      templatebody: "",
      culturetemplatebody: "",
      templatename: "",
      imgcount: 1,
      addValues: false,
      benifitIcon: "roboposition1",
      benifitTitle: "",
      overviewTitle: "",
      overviewValue: "",
      emojiPicker: false,
      locations: [],
      locationid: "",
      twounicode: "",
    };

    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.getFiles = this.getFiles.bind(this);
    this.onDeleteDoc = this.onDeleteDoc.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.updateDrawerData = this.updateDrawerData.bind(this);
    this.AddDrawerData = this.AddDrawerData.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onEmojiClick = this.onEmojiClick.bind(this);
    this.closeDrawerdata = this.closeDrawerdata.bind(this);
    this.GetLocationList = this.GetLocationList.bind(this);
  }

  GetLocationList(props) {
    const data = {
      // featurekey: "directory",
      subscriptionid: get(this.props, "SubscriptionData.subscriptionid", ""),
    };
    instance
      .post(`subscription/allcompanylocation`, data)
      .then((result) => {
        let locations = [];
        if (result.data.result.length > 0) {
          locations = result.data.result;
          if (props.postData.careerpagesectionid != null) {
            props.postData.sectiondetail.map((x) => {
              const tempid = x.linkedid;
              if (tempid) {
                const locationname = locations.find(
                  (y) => y.displayvalue == tempid,
                );
                x.locationame = locationname && locationname.displayname;
              }
              return x;
            });
          }
        }
        this.setState({ locations, postData: props.postData });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  onEdit(item, index) {
    item.index = index;
    this.setState({
      sectiondetail: item,
      right: true,
      isedit: true,
    });
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  updateDrawerData(key, value) {
    const { sectiondetail, locations } = this.state;
    const locationame = locations.find((x) => x.displayvalue == value);
    sectiondetail[key] = value;
    sectiondetail.locationame = locationame && locationame.displayname;
    this.setState({
      sectiondetail,
    });
  }

  closeDrawerdata() {
    this.setState({
      right: false,
      sectiondetail: {
        careerpagesectiondetailid: null,
        title: null,
        description: null,
        linkedid: null,
        locationame: null,
        documentpath: null,
        documenttypeid: null,
      },
    });
  }

  onDeleteDoc(key, value, index = null) {
    const { postData, sectiondetail } = this.state;
    if (value == 1) {
      postData.sectiondetail.splice(index, 1);
      // postData.sectiondetail[index].documentpath = " ";
      this.setState({ postData });
    }
    if (value == 2) {
      if (index) {
        postData.sectiondetail[index].documentpath = null;
      }
      sectiondetail.documentpath = null;

      this.setState({
        postData,
        sectiondetail,
      });
    }
  }

  AddDrawerData() {
    console.log("hello");
    const { postData, sectiondetail, isedit } = this.state;
    if (
      (postData.sectiontypeid == 4 ||
        postData.sectiontypeid == 5 ||
        postData.sectiontypeid == 6 ||
        postData.sectiontypeid == 7) &&
      sectiondetail.title == null
    ) {
      this.props.enqueueSnackbar("Please enter title", {
        variant: "error",
      });
    }

    // else if (
    //   (postData.sectiontypeid == 4 ||
    //     postData.sectiontypeid == 5 ||
    //     postData.sectiontypeid == 7) &&
    //   sectiondetail.description == null
    // ) {
    //   this.props.enqueueSnackbar("Please enter description", {
    //     variant: "error",
    //   });
    // }
    else if (postData.sectiontypeid == 8 && sectiondetail.linkedid == null) {
      this.props.enqueueSnackbar("Please select location", {
        variant: "error",
      });
    } else if (
      (postData.sectiontypeid == 8 ||
        postData.sectiontypeid == 4 ||
        postData.sectiontypeid == 6) &&
      sectiondetail.documentpath == null
    ) {
      this.props.enqueueSnackbar("Please upload image", {
        variant: "error",
      });
    } else if (
      postData.sectiontypeid == 5 &&
      sectiondetail.documentpath == null
    ) {
      this.props.enqueueSnackbar("Please add emoji", {
        variant: "error",
      });
    } else {
      const data = {
        careerpagesectiondetailid: null,
        title: null,
        description: null,
        linkedid: null,
        locationame: null,
        documentpath: null,
        documenttypeid: null,
      };

      if (isedit == false) {
        postData.sectiondetail.push(sectiondetail);
      } else {
        postData.sectiondetail[sectiondetail.index] = sectiondetail;
      }
      this.setState({
        postData,
        right: false,
        sectiondetail: data,
        isedit: false,
      });
    }
  }

  async getFiles(key, files, id, iscoverphoto = false) {
    console.log("files: ", files);
    const { sectiondetail, postData } = this.state;
    const formData = new FormData();
    formData.append("file", files[0]);
    if (files.length == 0) {
      this.props.enqueueSnackbar("Please select Valid image. (Maxsize : 2MB)", {
        variant: "error",
      });
      return false;
    }
    instanceMultipart
      .post(
        `/drive/uploaddocument/${this.props.AuthenticationAction.login.subscriptionid}/${this.props.login.employeeid}`,
        formData,
      )
      .then((resp) => {
        console.log("resp.data.result: ", resp);
        if (id == 2) {
          sectiondetail[key] = resp.data.result[0].imagepath;
          sectiondetail.documenttypeid =
            getDocTypeid[resp.data.result[0].extension];
          this.setState({
            sectiondetail,
          });
        }
        if (id == 1) {
          sectiondetail[key] = resp.data.result[0].imagepath;
          sectiondetail.documenttypeid =
            getDocTypeid[resp.data.result[0].extension];
          if (
            iscoverphoto &&
            postData &&
            postData.sectiondetail[0] &&
            postData.sectiondetail[0].documentpath
          ) {
            postData.sectiondetail[0].documentpath =
              resp.data.result[0].imagepath;
            postData.sectiondetail[0].documenttypeid =
              getDocTypeid[resp.data.result[0].extension];
            this.setState({
              postData,
            });
          } else {
            postData && postData.sectiondetail.push(sectiondetail);
            this.setState({
              postData,
            });
          }
        }
      });
  }

  onEmojiClick(value, key, id) {
    console.log("value, key, id: ", value, key);
    const { sectiondetail } = this.state;
    // const index = ratings.findIndex((x) => x.ratingscaletypeid == id);
    sectiondetail[key] = value.unified;
    sectiondetail.documenttypeid = id;
    console.log("ratings: ", sectiondetail);
    this.setState({
      sectiondetail,
      selectedscale: null,
      scalenum: null,
      emojiPicker: false,
    });
  }

  toggleDrawer = (side, open, sectiontypeid, flag) => () => {
    if (sectiontypeid == "3") {
      this.setState({
        isValues: true,
        isOverview: false,
        isBenifits: false,
        isTeamStructure: false,
        [side]: open,
      });
    } else if (sectiontypeid == "4") {
      this.setState({
        isOverview: true,
        isValues: false,
        isBenifits: false,
        isTeamStructure: false,
        [side]: open,
      });
    } else if (sectiontypeid == "5") {
      this.setState({
        isBenifits: true,
        isOverview: false,
        isValues: false,
        isTeamStructure: false,
        [side]: open,
      });
    } else if (flag == "isTeamStructure") {
      this.setState({
        isTeamStructure: true,
        isBenifits: false,
        isOverview: false,
        isValues: false,
        [side]: open,
      });
    } else if (!flag) {
      this.setState({
        [side]: open,
      });
    }
  };

  getFiles1(files) {
    const { postData } = this.state;
    const formData = new FormData();
    files.forEach((fil) => {
      formData.append("file", fil);
    });
    console.log("files: ", files);
    // if (isreplace ? files.length != 1 : files.length > 10) {
    //   this.props.enqueueSnackbar("Maximum file upload limit exceed", {
    //     variant: "error",
    //   });
    //   this.setState({ loading: false });
    //   return false;
    // }image/gif, image/jpeg, image/png
    if (
      files[0].type == "image/gif" ||
      files[0].type == "image/jpeg" ||
      files[0].type == "image/png"
        ? files.length > 3
        : files.length > 1
    ) {
      this.props.enqueueSnackbar("Maximum file upload limit exceed", {
        variant: "error",
      });
      this.setState({ loading: false });
      return false;
    }
    // if (files.length == 0) {
    //   this.props.enqueueSnackbar("Please select Valid image. (Maxsize : 2MB)", {
    //     variant: "error",
    //   });
    //   return false;
    // }
    instanceMultipart
      .post(
        `/drive/uploaddocument/${this.props.AuthenticationAction.login.subscriptionid}/${this.props.login.employeeid}`,
        formData,
      )
      .then((resp) => {
        if (resp.data.result.length >= 1) {
          console.log("resp.data.result: ", resp.data.result);
          resp.data.result.forEach((item) => {
            const obj = {
              careerpagesectiondetailid: null,
              title: null,
              description: null,
              linkedid: null,
              documentpath: item.imagepath,
              documenttypeid: getDocTypeid[item.extension],
            };
            postData.sectiondetail.push(obj);
            this.setState({
              postData,
            });
          });
        }
      });
  }

  async componentDidMount() {
    const data = {
      featurekey: "requestCenter",
    };
    let sectionType = await GetMasterData("CareerPageSectionType");
    const documenttype = await GetMasterData("DocumentType");
    sectionType = sectionType.data.result.filter(
      (item) =>
        !this.state.listdata.some((x) => x.sectiontypename == item.displayname),
    );
    this.setState({
      sectionType,
      documenttype: documenttype.data.result,
    });
    this.GetLocationList(this.props);
  }

  onDelete(item, index) {
    const { postData } = this.state;
    postData.sectiondetail.splice(index, 1);
    this.setState({ postData });
  }

  handleChange(key, value) {
    const { postData } = this.state;
    if (key == "sectiontypeid") {
      this.setState({
        postData: {
          careerpagesectionid: null,
          title: null,
          sectiontypeid: value,
          sectionbodypath: null,
          description: null,
          sectiondetail: [],
        },
      });
    } else {
      postData[key] = value;
      this.setState({ postData });
    }
  }

  async uploadFile() {
    const { postData } = this.state;

    if (postData.sectionbodypath) {
      if (
        postData.careerpagesectionid &&
        postData.sectionbody != postData.sectionbodypath
      ) {
        postData.sectionbody = postData.sectionbody.toString();
        const data = {
          filename: "career_page_section.html",
          appproductid: null,
          contenttype: "application/html",
          bufferdata: convertTOBase64(postData.sectionbody),
          employeeid: null,
        };
        const result = await instance.post("employee/uploadbufferfile", data);
        postData.sectionbodypath = result.data.result[0].imagepath;
        // postData.deletefile.push(postData.bemailbodypath);
      } else {
        postData.sectionbodypath = postData.sectionbodypath.toString();
        const data = {
          filename: "career_page_section.html",
          appproductid: null,
          contenttype: "application/html",
          bufferdata: convertTOBase64(postData.sectionbodypath),
          employeeid: null,
        };
        await instance
          .post("employee/uploadbufferfile", data)
          .then((result) => {
            console.log("result: ", result.data.result[0].imagepath);
            postData.sectionbodypath = result.data.result[0].imagepath;
            console.log("postData.sectionbodypath: ", postData.sectionbodypath);
            // this.setState({ postData });
            console.log("postData: ", postData);
          });
      }
    }
  }

  async formValidation() {
    const { postData } = this.state;

    if (!postData.sectiontypeid) {
      this.props.enqueueSnackbar(" Please select section type", {
        variant: "error",
      });
      return false;
    } else if (
      postData.sectiontypeid == 1 &&
      ((postData.sectiondetail && postData.sectiondetail.length == 0) ||
        !postData.sectiondetail ||
        !postData.sectiondetail[0] ||
        !postData.sectiondetail[0].documentpath)
    ) {
      this.props.enqueueSnackbar("Please upload cover photo", {
        variant: "error",
      });
      return false;
    } else if (postData.title == null) {
      this.props.enqueueSnackbar("Please enter title of this section", {
        variant: "error",
      });
      return false;
    } else if (
      (postData.sectiontypeid == 2 || postData.sectiontypeid == 3) &&
      postData.sectionbodypath == null
    ) {
      this.props.enqueueSnackbar("Please enter description of this section", {
        variant: "error",
      });
      return false;
    } else if (
      (postData.sectiontypeid == 2 || postData.sectiontypeid == 3) &&
      (postData.sectiondetail == null ||
        undefined ||
        postData.sectiondetail.length == 0)
    ) {
      this.props.enqueueSnackbar("Please upload at least one photo", {
        variant: "error",
      });
      return false;
    } else if (
      (postData.sectiontypeid == 4 ||
        postData.sectiontypeid == 5 ||
        postData.sectiontypeid == 6 ||
        postData.sectiontypeid == 7 ||
        postData.sectiontypeid == 8) &&
      postData.sectiondetail.length == 0
    ) {
      this.props.enqueueSnackbar("Please add atleast one section", {
        variant: "error",
      });
      return false;
    } else {
      return true;
    }
  }

  async onSave() {
    let { postData, isDisableSaveButton } = this.state;
    if (await this.formValidation()) {
      this.uploadFile().then(() => {
        if (!isDisableSaveButton) {
          isDisableSaveButton = true;
          instance
            .post(`recruit/configcareerpage`, postData)
            .then(() => {
              this.props.enqueueSnackbar("Saved successfully", {
                variant: "success",
              });
              this.setState(
                {
                  isDisableSaveButton: false,
                  postData: {
                    careerpagesectionid: null,
                    title: null,
                    sectiontypeid: null,
                    sectionbodypath: null,
                    description: null,
                    sectiondetail: [],
                  },
                },
                () => {
                  this.props.removeSaveProgress();
                  this.props.history.push(`${this.props.match.path}/list`);
                  this.props.onCancel();
                },
              );
            })
            .catch((error) => {
              this.props.removeSaveProgress();
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
              this.setState({ isDisableSaveButton: false });
            });
        }
      });
    } else console.log("Error on save");
  }

  render() {
    const { postData, sectiondetail } = this.state;
    const { classes } = this.props;
    return (
      <div>
        <div className="content-outer-wrapper" style={{ paddingBottom: 93 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} sm={12}>
              <div>
                <div>
                  <PageHeader
                    header={
                      postData && postData.careerpagesectionid != null
                        ? "Edit this section"
                        : "Add new section"
                    }
                  />
                  <div style={{ width: 360 }}>
                    <DynamicForm
                      fields={selectinputconverter({
                        value: postData && postData.sectiontypeid,
                        placeholder:
                          postData && postData.careerpagesectionid != null
                            ? postData.sectiontypename
                            : " ",
                        label: "Select section to add",
                        options: this.state.sectionType,
                        disabled:
                          postData && postData.careerpagesectionid != null
                            ? true
                            : false,
                      })}
                      onChange={(value) => {
                        this.handleChange("sectiontypeid", value);
                      }}
                    />

                    <DynamicForm
                      fields={textinputconverter({
                        value: postData && postData.title,
                        label: "Title",
                        placeholder: "Enter title",
                        maxLength: 100,
                      })}
                      onChange={(value) => {
                        this.handleChange("title", value);
                      }}
                    />

                    {postData && postData.sectiontypeid == 2 && (
                      <div className="margin-bottom-16">
                        <ReactQuill
                          theme="snow"
                          value={
                            postData.careerpagesectionid != null
                              ? postData.sectionbody
                              : postData.sectionbodypath
                          }
                          modules={this.state.modules}
                          formats={this.state.formats}
                          onChange={(value) => {
                            this.handleChange(
                              postData.careerpagesectionid != null
                                ? "sectionbody"
                                : "sectionbodypath",
                              value,
                            );
                          }}
                        />
                      </div>
                    )}

                    {postData && postData.sectiontypeid == 3 && (
                      <div className="margin-bottom-16">
                        <ReactQuill
                          theme="snow"
                          value={
                            postData.careerpagesectionid != null
                              ? postData.sectionbody
                              : postData.sectionbodypath
                          }
                          modules={this.state.modules}
                          formats={this.state.formats}
                          onChange={(value) => {
                            this.handleChange(
                              postData.careerpagesectionid != null
                                ? "sectionbody"
                                : "sectionbodypath",
                              value,
                            );
                          }}
                        />
                      </div>
                    )}
                    {postData &&
                      postData.sectiontypeid == 4 &&
                      postData.sectiondetail && (
                        <Grid container>
                          <Grid item xs={12} md={12} sm={12}>
                            {postData.sectiondetail.map((x, index) => (
                              <div
                                className="rounded-rectangle-div margin-bottom-16 display-flex"
                                style={{ alignItems: "end" }}
                              >
                                <span className="margin-right-16">
                                  <img
                                    src={getFormattedImageLink(x.documentpath)}
                                    height="40"
                                  ></img>
                                </span>
                                <span className="small-dark-secondary width70">
                                  <span className="display-block margin-bottom-8 ellipsis">
                                    {x.title}
                                  </span>
                                  <span className="display-block ellipsis">
                                    {x.description}
                                  </span>
                                </span>
                                <span className="display-flex">
                                  <img
                                    src={editIcon}
                                    className="margin-right-16"
                                    onClick={() => this.onEdit(x, index)}
                                  ></img>
                                  <img
                                    src={deleteIcon}
                                    onClick={() => this.onDelete(x, index)}
                                  ></img>
                                </span>
                              </div>
                            ))}
                          </Grid>
                        </Grid>
                      )}

                    {postData &&
                      postData.sectiontypeid == 6 &&
                      postData.sectiondetail && (
                        <Grid container>
                          <Grid item xs={12} md={12} sm={12}>
                            {postData.sectiondetail.map((x, index) => (
                              <div
                                className="rounded-rectangle-div margin-bottom-16 display-flex"
                                style={{ alignItems: "end" }}
                              >
                                <span className="margin-right-16">
                                  <img
                                    src={getFormattedImageLink(x.documentpath)}
                                    height="40"
                                  ></img>
                                </span>
                                <span className="small-dark-secondary width70">
                                  <span className="display-block margin-bottom-8 ellipsis">
                                    {x.title}
                                  </span>
                                </span>
                                <span className="display-flex">
                                  <img
                                    src={editIcon}
                                    className="margin-right-16"
                                    onClick={() => this.onEdit(x, index)}
                                  ></img>
                                  <img
                                    src={deleteIcon}
                                    onClick={() => this.onDelete(x, index)}
                                  ></img>
                                </span>
                              </div>
                            ))}
                          </Grid>
                        </Grid>
                      )}

                    {postData &&
                      postData.sectiontypeid == 5 &&
                      postData.sectiondetail && (
                        <Grid container>
                          <Grid item xs={12} md={12} sm={12}>
                            {postData.sectiondetail.map((x, index) => (
                              <div
                                className="rounded-rectangle-div margin-bottom-16 display-flex"
                                style={{ alignItems: "end" }}
                              >
                                <span className="margin-right-16">
                                  {String.fromCodePoint(
                                    parseInt(x.documentpath, 16),
                                  )}
                                  {/* {getFormattedImageLink(x.documentpath)} */}
                                </span>
                                <span className="small-dark-secondary width70">
                                  <span className="display-block margin-bottom-8 ellipsis">
                                    {x.title}
                                  </span>
                                  <span className="display-block ellipsis">
                                    {x.description}
                                  </span>
                                </span>
                                <span className="display-flex">
                                  <img
                                    src={editIcon}
                                    className="margin-right-16"
                                    onClick={() => this.onEdit(x, index)}
                                  ></img>
                                  <img
                                    src={deleteIcon}
                                    onClick={() => this.onDelete(x, index)}
                                  ></img>
                                </span>
                                <div className="clear-float"></div>
                              </div>
                            ))}
                          </Grid>
                        </Grid>
                      )}

                    {postData &&
                      postData.sectiontypeid == 7 &&
                      postData.sectiondetail && (
                        <Grid container>
                          <Grid item xs={12} md={12} sm={12}>
                            {postData.sectiondetail.map((x, index) => (
                              <div
                                className="rounded-rectangle-div margin-bottom-16 display-flex"
                                style={{
                                  alignItems: "end",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span className="small-dark-secondary width80">
                                  <span className="display-block margin-bottom-8 ellipsis">
                                    {x.title}
                                  </span>
                                  <span className="display-block ellipsis">
                                    {x.description}
                                  </span>
                                </span>
                                <span className="display-flex">
                                  <img
                                    src={editIcon}
                                    onClick={() => this.onEdit(x, index)}
                                    className="margin-right-16"
                                  ></img>
                                  <img
                                    src={deleteIcon}
                                    onClick={() => this.onDelete(x, index)}
                                  ></img>
                                </span>
                              </div>
                            ))}
                          </Grid>
                        </Grid>
                      )}

                    {postData &&
                      postData.sectiontypeid == 8 &&
                      postData.sectiondetail && (
                        <Grid container>
                          <Grid item xs={12} md={12} sm={12}>
                            {postData.sectiondetail.map((x, index) => (
                              <div
                                className="rounded-rectangle-div margin-bottom-16 padding4 display-flex"
                                style={{ alignItems: "end" }}
                              >
                                <span className="margin-right-16">
                                  <div>
                                    {x.documentpath == null ? (
                                      <div className="about-us-file-uploader">
                                        <Tooltip
                                          title="Upload file"
                                          placement="right"
                                        >
                                          <Dropzone
                                            onDrop={(files) =>
                                              this.getFiles(
                                                "documentpath",
                                                files,
                                                2,
                                              )
                                            }
                                            multiple={false}
                                            accept="image/gif, image/jpeg, image/png, image/jpg, video/avi, video/flv, video/mp4, video/webm, video/wmv"
                                            maxSize={2000000}
                                            className="drag-drop"
                                          >
                                            <Add className="add-attachement-icon" />
                                          </Dropzone>
                                        </Tooltip>
                                      </div>
                                    ) : (
                                      <div className="about-us-file-uploader">
                                        <ThumbnailBig
                                          key="key"
                                          onDelete={() =>
                                            this.onDeleteDoc(
                                              "x.documentpath",
                                              1,
                                              index,
                                            )
                                          }
                                          onEdit={(file) =>
                                            this.getFiles1(
                                              "x.documentpath",
                                              file,
                                            )
                                          }
                                          filetypes="image/*"
                                          doc={{
                                            url: getFormattedImageLink(
                                              x.documentpath,
                                            ),
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </span>
                                <span className="small-dark-secondary margin-top-16 display-block ellipsis width70">
                                  {x.locationame}
                                </span>
                                <span className="margin-top-4 margin-right-8 cursor-pointer">
                                  <img
                                    src={deleteIcon}
                                    className="vertical-middle"
                                    onClick={() => this.onDelete(x, index)}
                                  ></img>
                                </span>
                              </div>
                            ))}
                          </Grid>
                        </Grid>
                      )}

                    {postData &&
                    postData.sectiontypeid != 2 &&
                    postData.sectiontypeid != 3 &&
                    postData.sectiontypeid != 8 &&
                    postData.sectiontypeid != 1 &&
                    postData.sectiontypeid != null ? (
                      <Button
                        className="btn btn-primary-md-blue margin-top-16"
                        variant="contained"
                        onClick={this.toggleDrawer(
                          "right",
                          true,
                          postData.sectiontypeid,
                        )}
                      >
                        Add section
                      </Button>
                    ) : (
                      postData &&
                      postData.sectiontypeid == 8 && (
                        <Button
                          className="btn btn-primary-md-blue margin-top-16"
                          variant="contained"
                          onClick={this.toggleDrawer(
                            "right",
                            true,
                            postData.sectiontypeid,
                          )}
                        >
                          Add location
                        </Button>
                      )
                    )}
                  </div>
                </div>

                {postData && postData.sectiontypeid == 1 && (
                  <div
                    style={{ width: 360 }}
                    className="career-page-upload-cover-photo"
                  >
                    <p className="input-label margin-bottom-4">
                      Upload cover photo
                    </p>
                    {postData &&
                    postData.sectiondetail &&
                    postData.sectiondetail.length > 0 ? (
                      <ThumbnailBig
                        key="key"
                        onDelete={() => this.onDeleteDoc("documentpath", 1)}
                        onEdit={(file) =>
                          this.getFiles("documentpath", file, 1, true)
                        }
                        filetypes="image/*"
                        doc={{
                          url: getFormattedImageLink(
                            postData &&
                              postData.sectiondetail &&
                              postData.sectiondetail[0] &&
                              postData.sectiondetail[0].documentpath,
                          ),
                        }}
                      />
                    ) : (
                      <Tooltip title="Upload image" placement="top">
                        <Dropzone
                          onDrop={(files) =>
                            this.getFiles("documentpath", files, 1, true)
                          }
                          multiple={false}
                          accept="image/*"
                          maxSize={2000000}
                          className="drag-drop"
                        >
                          <div className="uploader-wrapper cursor-pointer">
                            <div
                              className="vertical-center"
                              style={{ height: 20 }}
                            >
                              <img
                                src={uploadIcon}
                                className="vertical-middle"
                              ></img>
                              <span className="margin-left-16 small-blue">
                                Upload image
                              </span>
                            </div>
                          </div>
                        </Dropzone>
                      </Tooltip>
                    )}
                    <div style={{ width: 360, marginTop: 16 }}>
                      <CallOutNew
                        classnames="bg-light-blue display-flex margin-bottom-16"
                        header="Image dimensions - Height: 512px, Width: 100% of screen width. Upload photo with max size 2 MB for optimum results.
                        (Supports .gif, .jpeg, .jpg and .png file types)"
                        emoji="ℹ️"
                        textcolor="#1e8ced"
                      />
                    </div>
                  </div>
                )}

                {postData && postData.sectiontypeid == 2 && (
                  <div>
                    <p className="small-dark-secondary margin-bottom-8">
                      Add upto 3 photos OR 1 video
                    </p>

                    {postData &&
                      postData.sectiondetail &&
                      postData.sectiondetail.length > 0 && (
                        <Grid container style={{ flexDirection: "column" }}>
                          {postData &&
                            postData.sectiondetail &&
                            postData.sectiondetail.map((x, index) => (
                              <Grid
                                item
                                sm={12}
                                md={4}
                                className="margin-bottom-16"
                              >
                                <Dropzone
                                  onDrop={this.getFiles1.bind(this)}
                                  multiple={true}
                                  accept="image/gif, image/jpeg, image/png, image/jpg, video/avi, video/flv, video/mp4, video/webm, video/wmv "
                                  maxSize={2000000}
                                  // className="drag-drop floatleft"
                                  className="drag-drop"
                                ></Dropzone>
                                <div className="about-us-file-uploader">
                                  <ThumbnailBig
                                    key="key"
                                    onDelete={() =>
                                      this.onDeleteDoc(
                                        "x.documentpath",
                                        1,
                                        index,
                                      )
                                    }
                                    onEdit={(file) =>
                                      this.getFiles1("x.documentpath", file)
                                    }
                                    filetypes="image/*"
                                    doc={{
                                      url: getFormattedImageLink(
                                        x.documentpath,
                                      ),
                                    }}
                                  />
                                </div>
                              </Grid>
                            ))}
                        </Grid>
                      )}
                    {postData &&
                      ((postData.sectiondetail &&
                        postData.sectiondetail.length < 3) ||
                        !postData.sectiondetail) && (
                        <Grid container>
                          <Grid item sm={12} md={4}>
                            <div
                              className="add-attachment"
                              style={{
                                width: 100,
                                padding: 6,
                                height: 50,
                                textAlign: "center",
                              }}
                            >
                              <Tooltip
                                title="Insert attachment"
                                placement="right"
                              >
                                <Dropzone
                                  onDrop={this.getFiles1.bind(this)}
                                  multiple={true}
                                  accept="image/gif, image/jpeg, image/png, image/jpg, , video/avi, video/flv, video/mp4, video/webm, video/wmv"
                                  maxSize={2000000}
                                  className="drag-drop"
                                >
                                  <Add
                                    className="add-attachement-icon"
                                    style={{ marginLeft: 0, marginTop: 0 }}
                                  />
                                  <div
                                    style={{
                                      fontSize: 12,
                                      color: "#057cff",
                                    }}
                                  >
                                    Click here to upload
                                  </div>
                                </Dropzone>
                              </Tooltip>
                            </div>
                          </Grid>
                        </Grid>
                      )}
                    <div style={{ width: 360 }}>
                      <CallOutNew
                        classnames="bg-light-blue display-flex margin-bottom-16"
                        header="Image dimensions - Height: 200px, Width: 200px. Upload photo with max size 2 MB for optimum results.
                        (Supports .gif, .jpeg, .jpg and .png file types)"
                        emoji="ℹ️"
                        textcolor="#1e8ced"
                      />
                    </div>
                  </div>
                )}

                {postData && postData.sectiontypeid == 3 && (
                  <div>
                    <p className="small-dark-secondary margin-bottom-8">
                      Add upto 3 photos OR 1 video
                    </p>

                    {postData &&
                      postData.sectiondetail &&
                      postData.sectiondetail.length > 0 && (
                        <Grid container style={{ flexDirection: "column" }}>
                          {postData &&
                            postData.sectiondetail &&
                            postData.sectiondetail.map((x, index) => (
                              <Grid
                                item
                                sm={12}
                                md={4}
                                className="margin-bottom-16"
                              >
                                <Dropzone
                                  onDrop={this.getFiles1.bind(this)}
                                  multiple={true}
                                  accept="image/gif, image/jpeg, image/png, image/jpg, video/avi, video/flv, video/mp4, video/webm, video/wmv "
                                  maxSize={2000000}
                                  className="drag-drop floatleft"
                                ></Dropzone>
                                <div className="about-us-file-uploader">
                                  <ThumbnailBig
                                    key="key"
                                    onDelete={() =>
                                      this.onDeleteDoc(
                                        "x.documentpath",
                                        1,
                                        index,
                                      )
                                    }
                                    onEdit={(file) =>
                                      this.getFiles1("x.documentpath", file)
                                    }
                                    filetypes="image/*"
                                    doc={{
                                      url: getFormattedImageLink(
                                        x.documentpath,
                                      ),
                                    }}
                                  />
                                </div>
                              </Grid>
                            ))}
                        </Grid>
                      )}

                    {postData &&
                      ((postData.sectiondetail &&
                        postData.sectiondetail.length < 3) ||
                        !postData.sectiondetail) && (
                        <Grid container>
                          <Grid item sm={12} md={4}>
                            <div
                              className="add-attachment"
                              style={{
                                width: 100,
                                padding: 6,
                                height: 50,
                                textAlign: "center",
                              }}
                            >
                              <Tooltip
                                title="Insert attachment"
                                placement="right"
                              >
                                <Dropzone
                                  onDrop={this.getFiles1.bind(this)}
                                  multiple={true}
                                  accept="image/gif, image/jpeg, image/png, image/jpg, video/avi, video/flv, video/mp4, video/webm, video/wmv"
                                  maxSize={2000000}
                                  className="drag-drop"
                                >
                                  <Add
                                    className="add-attachement-icon"
                                    style={{ marginLeft: 0, marginTop: 0 }}
                                  />
                                  <div
                                    style={{
                                      fontSize: 12,
                                      color: "#057cff",
                                    }}
                                  >
                                    Click here to upload
                                  </div>
                                </Dropzone>
                              </Tooltip>
                            </div>
                          </Grid>
                        </Grid>
                      )}
                    <div style={{ width: 360 }}>
                      <CallOutNew
                        classnames="bg-light-blue display-flex margin-bottom-16"
                        header="Image dimensions - Height: 200px, Width: 200px. Upload photo with max size 2 MB for optimum results.
                        (Supports .gif, .jpeg, .jpg and .png file types)"
                        emoji="ℹ️"
                        textcolor="#1e8ced"
                      />
                    </div>
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </div>

        <div
          className="width100"
          style={{
            position: "fixed",
            left: 0,
            background: "white",
            bottom: 0,
            padding: 10,
            borderTop: "1px solid #d4d4d4",
            zIndex: 0,
          }}
        >
          <div>
            <div className="floatleft" style={{ marginLeft: 304 }}>
              <div>
                <Button
                  className="btn btn-trans margin-right-16"
                  variant="contained"
                  onClick={this.props.onCancel}
                >
                  Cancel
                </Button>
              </div>
            </div>
            <div className="floatright" style={{ marginRight: 72 }}>
              <Button
                className="btn btn-primary-md-blue"
                variant="contained"
                onClick={this.onSave}
                disabled={this.state.isDisableSaveButton}
              >
                Save
              </Button>
            </div>
            <div className="clearfloat"></div>
          </div>
        </div>

        <Drawer
          anchor="right"
          open={this.state.right}
          onClose={this.closeDrawerdata}
          // this.toggleDrawer("right", false)}
          classes={{
            paper: classNames(classes.drawerPaper, "planner-drawer padding15"),
          }}
        >
          <DrawerHeader
            header="Add section details"
            isbackarrow={false}
            closeDrawer={this.closeDrawerdata}
          />
          {postData && postData.sectiontypeid == 8 ? (
            <div
              className="thin-scroll"
              style={{ height: "96vh", overflowY: "auto", paddingRight: 15 }}
            >
              <DynamicForm
                fields={selectinputconverter({
                  value: sectiondetail && sectiondetail.linkedid,
                  placeholder: "Select Location",
                  label: "Location",
                  options: this.state.locations,
                })}
                onChange={(selectedid) => {
                  this.updateDrawerData("linkedid", selectedid);
                }}
              />
              <p className="input-label">Add image</p>
              <div className="width50 margin-bottom-16">
                {sectiondetail && sectiondetail.documentpath != null ? (
                  <div
                    className="about-us-file-uploader"
                    style={{ width: 102 }}
                  >
                    <ThumbnailBig
                      key="key"
                      onDelete={() => this.onDeleteDoc("documentpath", 2)}
                      onEdit={(file) => this.getFiles("documentpath", file, 2)}
                      filetypes="image/*"
                      doc={{
                        url: getFormattedImageLink(sectiondetail.documentpath),
                      }}
                    />
                  </div>
                ) : (
                  <Tooltip title="Upload image" placement="top">
                    <Dropzone
                      onDrop={(e) => this.getFiles("documentpath", e, 2)}
                      multiple={false}
                      accept="image/*"
                      maxSize={2000000}
                      className="drag-drop"
                    >
                      <div className="uploader-wrapper cursor-pointer">
                        <div className="vertical-center" style={{ height: 20 }}>
                          <img
                            src={uploadIcon}
                            className="vertical-middle"
                          ></img>
                          <span className="margin-left-16 small-blue">
                            Upload image
                          </span>
                        </div>
                      </div>
                    </Dropzone>
                  </Tooltip>
                )}
              </div>
              <Button
                className="btn btn-primary-md-blue"
                variant="contained"
                onClick={() => this.AddDrawerData()}
              >
                {this.state.isedit ? "Update" : "Add"}
              </Button>
            </div>
          ) : (
            <div
              className="thin-scroll"
              style={{ height: "96vh", overflowY: "auto", paddingRight: 15 }}
            >
              <DynamicForm
                fields={textinputconverter({
                  value: sectiondetail && sectiondetail.title,
                  label: "Section title",
                  placeholder: "Enter section title",
                })}
                onChange={(value) => {
                  this.updateDrawerData("title", value);
                }}
              />
              {postData && postData.sectiontypeid != 6 && (
                <DynamicForm
                  fields={textareainputconverter({
                    value: sectiondetail && sectiondetail.description,
                    placeholder: "Enter description",
                    label: "Description",
                  })}
                  onChange={(value) => {
                    this.updateDrawerData("description", value);
                  }}
                />
              )}

              {postData && postData.sectiontypeid == 5 ? (
                <div>
                  <p className="input-label">Add icon</p>
                  <div
                    className="emoji-picker cursor-pointer margin-bottom-16"
                    onClick={() =>
                      this.setState({
                        emojiPicker: true,
                      })
                    }
                  >
                    <div
                      className="vertical-center"
                      style={{ height: 20, width: 22 }}
                    >
                      {sectiondetail && sectiondetail.documentpath != null ? (
                        <p className="normal-dark">
                          {String.fromCodePoint(
                            parseInt(sectiondetail.documentpath, 16),
                          )}
                        </p>
                      ) : (
                        <p className="normal-dark">😃</p>
                      )}
                    </div>
                  </div>
                  {this.state.emojiPicker && (
                    <ClickAwayListener
                      onClickAway={() => this.setState({ emojiPicker: false })}
                    >
                      <div
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 48,
                          zIndex: 1,
                        }}
                        // onBlur={() => this.setState({ emojiPicker: false })}
                      >
                        <Picker
                          onEmojiClick={(e, obj) =>
                            this.onEmojiClick(obj, "documentpath", 6)
                          }
                        />
                      </div>
                    </ClickAwayListener>
                  )}
                </div>
              ) : (
                postData &&
                postData.sectiontypeid != 7 && (
                  <div className="margin-top-16 margin-bottom-16 ">
                    {sectiondetail && sectiondetail.documentpath != null ? (
                      <div
                        className="about-us-file-uploader"
                        style={{ width: 102 }}
                      >
                        <ThumbnailBig
                          key="key"
                          onDelete={() => this.onDeleteDoc("documentpath", 2)}
                          onEdit={(file) =>
                            this.getFiles("documentpath", file, 2)
                          }
                          filetypes="image/*"
                          doc={{
                            url: getFormattedImageLink(
                              sectiondetail.documentpath,
                            ),
                          }}
                        />
                      </div>
                    ) : (
                      <Tooltip title="Upload image" placement="top">
                        <Dropzone
                          onDrop={(e) => this.getFiles("documentpath", e, 2)}
                          multiple={false}
                          accept="image/*"
                          maxSize={2000000}
                          className="drag-drop"
                        >
                          <div className="uploader-wrapper cursor-pointer">
                            <div
                              className="vertical-center"
                              style={{ height: 20 }}
                            >
                              <img
                                src={uploadIcon}
                                className="vertical-middle"
                              ></img>
                              <span className="margin-left-16 small-blue">
                                Upload image
                              </span>
                            </div>
                          </div>
                        </Dropzone>
                      </Tooltip>
                    )}
                  </div>
                )
              )}

              <div>
                <Button
                  className="btn btn-primary-md-blue"
                  variant="contained"
                  // onClick={() => this.setState({ flag: true })}
                  onClick={() => this.AddDrawerData()}
                >
                  Add
                </Button>
              </div>
            </div>
          )}
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  prop: state.prop,
  login: state.AuthenticationAction.login,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setSaveProgress, removeSaveProgress }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Create)));
